var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.items.length
    ? _c(
        "div",
        [
          _vm.items.length > 1
            ? _c("div", { staticClass: "lead-timeline-info" }, [
                _c("div", { staticClass: "timeline-avtor" }, [
                  _c(
                    "div",
                    { staticClass: "lead-timeline-action timeline-home" },
                    [_vm._v("Updates by")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "lead-timeline-employee" }, [
                    _vm._v(_vm._s(_vm.item.user_name) + ":"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "timline-date" }, [
                  _vm._v(_vm._s(_vm.item["date&time"])),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.items, function (el) {
            return el.update_type !== "create"
              ? _c("div", { staticClass: "lead-timeline__item" }, [
                  el.update_type === "leadstatus"
                    ? _c("div", { staticClass: "timeline__item_text" }, [
                        _c("span", { staticClass: "acth-type" }, [
                          _vm._v(_vm._s(el.update_type.toLowerCase()) + " by:"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "status-updated-wrapper" }, [
                          _c(
                            "div",
                            { staticClass: "lead-info-status td--salestatus" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "ui-ddbox ui-ddbox-select c-1",
                                  attrs: {
                                    "data-table": "",
                                    "data-id": "",
                                    "data-leadid": "",
                                    "data-task": "salestatus",
                                  },
                                },
                                [
                                  _c("button", { staticClass: "ui-ddbtn" }, [
                                    _c(
                                      "span",
                                      { staticClass: "ui-ddbtnvalue" },
                                      [_vm._v(_vm._s(el.old_value))]
                                    ),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "fa fa-caret-down",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _vm._m(0, true),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "status-updated__item status-updated-arrow",
                            },
                            [_vm._v("->")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "lead-info-status td--salestatus" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "ui-ddbox ui-ddbox-select c-1",
                                  attrs: {
                                    "data-table": "",
                                    "data-id": "",
                                    "data-leadid": "",
                                    "data-task": "salestatus",
                                  },
                                },
                                [
                                  _c("button", { staticClass: "ui-ddbtn" }, [
                                    _c(
                                      "span",
                                      { staticClass: "ui-ddbtnvalue" },
                                      [_vm._v(_vm._s(el.new_value))]
                                    ),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "fa fa-caret-down",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _vm._m(1, true),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  el.update_type === "assign"
                    ? _c("div", { staticClass: "timeline__item_text" }, [
                        _c("span", { staticClass: "acth-type" }, [
                          _vm._v(_vm._s(el.update_type.toLowerCase()) + " by:"),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(el.old_value))]),
                        _c("span", [_vm._v("->")]),
                        _c("span", [_vm._v(_vm._s(el.new_value))]),
                      ])
                    : _vm._e(),
                ])
              : _vm._e()
          }),
          _vm._v(" "),
          _vm.item.update_type === "create"
            ? _c("div", { staticClass: "lead-timeline-info" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "timline-date" }, [
                  _vm._v(_vm._s(_vm.item["date&time"])),
                ]),
              ])
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui-ddbody" }, [
      _c("div", { staticClass: "ui-ddsection ui-salestatusList" }, [_c("div")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ui-ddbody" }, [
      _c("div", { staticClass: "ui-ddsection ui-salestatusList" }, [_c("div")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "timeline-avtor" }, [
      _c("div", { staticClass: "lead-timeline-action timeline-lead-created" }, [
        _vm._v("Lead was created"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }